import Http from "./http";

export const updateEnrollmentAgreementStatusAPI = (payload) => {
  return Http.post("admin/campaign/enrollment-agreement/status", payload);
};

